import { Root, Portal, Overlay, Content, Trigger, Close } from "@radix-ui/react-dialog";
import { cx } from "class-variance-authority";

import styles from "./dialog.module.scss";

import type { ComponentProps, ReactNode } from "react";

export function Dialog({ children, ...props }: ComponentProps<typeof Root>) {
  return <Root {...props}>{children}</Root>;
}

type DialogTriggerT = {
  children: ReactNode;
};

export function DialogTrigger({ children }: DialogTriggerT) {
  return <Trigger asChild>{children}</Trigger>;
}

export function DialogContent({ children, className, ...props }: ComponentProps<typeof Content>) {
  return (
    <Portal>
      <Overlay className={styles.overlay} />

      <Content className={cx(className, styles.content)} {...props}>
        {children}
      </Content>
    </Portal>
  );
}

type DialogCloseT = {
  children: ReactNode;
};

export function DialogClose({ children }: DialogCloseT) {
  return <Close asChild>{children}</Close>;
}
